import React from 'react';
import { makeStyles, ListItem, ListItemText, Chip, Typography, ListItemSecondaryAction, Tooltip, IconButton } from '@material-ui/core';
import { DateTime, Duration } from 'luxon';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import { Link } from '@backstage/core-components';

const useStyles = makeStyles((theme) => ({
  denseListIcon: {
    marginRight: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  listItemPrimary: {
    fontWeight: "bold"
  },
  warning: {
    borderColor: theme.palette.warning.main,
    color: "#fff",
    backgroundColor: theme.palette.warning.main,
    boxShadow: "0 4px 4px 0 rgba(0,0,0,0.2)",
    textTransform: "uppercase",
    "& *": {
      color: "#fff"
    }
  },
  error: {
    borderColor: theme.palette.error.main,
    color: "#fff",
    backgroundColor: theme.palette.error.main,
    boxShadow: "0 4px 4px 0 rgba(0,0,0,0.2)",
    textTransform: "uppercase",
    "& *": {
      color: "#fff"
    }
  },
  lowUrgency: {
    borderColor: theme.palette.warning.main,
    color: theme.palette.warning.main,
    backgroundColor: "#fff",
    boxShadow: "0 4px 4px 0 rgba(0,0,0,0.2)",
    textTransform: "uppercase",
    "& *": {
      color: theme.palette.warning.main
    }
  },
  highUrgency: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    backgroundColor: "#fff",
    boxShadow: "0 4px 4px 0 rgba(0,0,0,0.2)",
    textTransform: "uppercase",
    "& *": {
      color: theme.palette.error.main
    }
  },
  textContainer: {
    display: "flex",
    alignItems: "baseline"
  },
  smallIconStyle: {
    color: theme.palette.text.primary,
    marginRight: "-20px"
  }
}));
const IncidentListItem = ({ incident }) => {
  var _a, _b, _c;
  const classes = useStyles();
  const duration = (/* @__PURE__ */ new Date()).getTime() - new Date(incident.created_at).getTime();
  const createdAt = DateTime.local().minus(Duration.fromMillis(duration)).toRelative({ locale: "en" });
  const user = (_a = incident.assignments[0]) == null ? void 0 : _a.assignee;
  return /* @__PURE__ */ React.createElement(ListItem, { dense: true, key: incident.id }, /* @__PURE__ */ React.createElement(
    ListItemText,
    {
      primary: /* @__PURE__ */ React.createElement("div", { className: classes.textContainer }, /* @__PURE__ */ React.createElement(
        Chip,
        {
          "data-testid": `chip-${incident.status}`,
          label: incident.status,
          size: "small",
          variant: "outlined",
          className: incident.status === "triggered" ? classes.error : classes.warning
        }
      ), /* @__PURE__ */ React.createElement(
        Chip,
        {
          "data-testid": `chip-${incident.urgency}`,
          label: `${incident.urgency} urgency`,
          size: "small",
          variant: "outlined",
          className: incident.urgency === "high" ? classes.highUrgency : classes.lowUrgency
        }
      ), incident.title),
      primaryTypographyProps: {
        variant: "body1",
        className: classes.listItemPrimary
      },
      secondary: /* @__PURE__ */ React.createElement(Typography, { noWrap: true, variant: "body2", color: "textSecondary" }, "Created ", createdAt, " and assigned to", " ", /* @__PURE__ */ React.createElement(Link, { to: (_b = user == null ? void 0 : user.html_url) != null ? _b : "#" }, (_c = user == null ? void 0 : user.summary) != null ? _c : "nobody"))
    }
  ), /* @__PURE__ */ React.createElement(ListItemSecondaryAction, null, /* @__PURE__ */ React.createElement(Tooltip, { title: "View in PagerDuty", placement: "top" }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      href: incident.html_url,
      target: "_blank",
      rel: "noopener noreferrer",
      className: classes.smallIconStyle
    },
    /* @__PURE__ */ React.createElement(OpenInBrowserIcon, null)
  ))));
};

export { IncidentListItem };
//# sourceMappingURL=IncidentListItem.esm.js.map
